//
export const GET_CONFIG_REQUEST = 'GET_CONFIG_REQUEST';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = 'GET_CONFIG_ERROR';
export const GET_COMPANY_UI_CONFIG_REQUEST = 'GET_COMPANY_UI_CONFIG_REQUEST';
export const GET_COMPANY_UI_CONFIG_SUCCESS = 'GET_COMPANY_UI_CONFIG_SUCCESS';
export const GET_COMPANY_UI_CONFIG_ERROR = 'GET_COMPANY_UI_CONFIG_ERROR';
export const UPDATE_COMPANY_UI_CONFIG_REQUEST =
  'UPDATE_COMPANY_UI_CONFIG_REQUEST';
export const UPDATE_COMPANY_UI_CONFIG_SUCCESS =
  'UPDATE_COMPANY_UI_CONFIG_SUCCESS';
export const UPDATE_COMPANY_UI_CONFIG_ERROR = 'UPDATE_COMPANY_UI_CONFIG_ERROR';
export const UPDATE_MACHINE_METRICS_CONFIG = 'UPDATE_MACHINE_METRICS_CONFIG';
export const TOGGLE_SIDEBAR_COLLAPSED = 'TOGGLE_SIDEBAR_COLLAPSED';
